export enum DeviceType {
  PHONE = 'PHONE',
  SERVICE = 'SERVICE',
  BUSINESS_TRUNK = 'BUSINESS_TRUNK',
}
